import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Pages404 from "pages/Utility/pages-404";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
// Import scss
import "./assets/scss/theme.scss";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes";
// Import all middleware
import Authmiddleware from "./routes/route";

// Activating fake backend
// fakeBackend()

// const firebaseConfig = {
//   apiKey: process.env.                      ,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // retryDelay: (attemptIndex) => {
      //   const storageAuthRefreshToken = getStorageData(CHECK_AUTH_REFRESH_TOKEN);

      //   if (storageAuthRefreshToken === "YES") {
      //     if (!dataAuthRefreshToken) {
      //       dispatch(checkAuthRefreshToken({ data: storageAuthRefreshToken }));
      //     }
      //     return 3000;
      //   }

      //   return Math.min(2000 * 2 ** attemptIndex, 30000);
      // },
    },
    mutations: {
      // retryDelay: (attemptIndex) => {
      //   const storageAuthRefreshToken = getStorageData(CHECK_AUTH_REFRESH_TOKEN);
      //   if (storageAuthRefreshToken === "YES") {
      //     if (!dataAuthRefreshToken) {
      //       dispatch(checkAuthRefreshToken({ data: storageAuthRefreshToken }));
      //     }
      //     return 3000;
      //   }
      //   return Math.min(2000 * 2 ** attemptIndex, 30000);
      // },
    },
  },
});
const App = props => {
  function getLayout() {
    let layoutCls = VerticalLayout;
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout = getLayout();
  return (
    <React.Fragment>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Switch>
            {publicRoutes.map((route, idx) => (
              <Authmiddleware
                path={route.path}
                layout={NonAuthLayout}
                component={route.component}
                key={idx}
                isAuthProtected={false}
                exact
              />
            ))}

            {authProtectedRoutes.map((route, idx) => (
              <Authmiddleware
                path={route.path}
                layout={route.isNoneLayout ? NonAuthLayout : Layout}
                component={route.component}
                key={idx}
                isAuthProtected={true}
                exact
              />
            ))}
            <Route component={Pages404} />
          </Switch>
        </Router>
        {/* <ReactQueryDevtools initialIsOpen={false} position="bottom-right" /> */}
      </QueryClientProvider>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
